module.exports = __webpack_public_path__ + "9cae6216caa5378bafec365f20990205.png";